<template>
  <FinishedArtworkRow v-if='isArtworkFinished()'
                      :artwork="artwork"
                      :index="index"
                      :id="`artwork_${artwork.id}`" />
  <IncomingArtworkRow v-else
                      :artwork="artwork"
                      :index="index"
                      :id="`artwork_${artwork.id}`" />
</template>

<script>
  import { FINISHED_AUCTIONS_CATALOG_STATE } from '../../consts';
  import FinishedArtworkRow from './row/finished_artwork_row';
  import IncomingArtworkRow from './row/incoming_artwork_row';

  export default {
    name: 'ArtworkRow',
    data() {
      return {
        finishedAuctionsCatalogState: FINISHED_AUCTIONS_CATALOG_STATE,
      };
    },
    components: {
      FinishedArtworkRow,
      IncomingArtworkRow,
    },
    props: {
      artwork: {
        type: Object,
        required: true,
      },
      index: {
        type: Number,
        required: true,
      },
    },
    methods: {
      isArtworkFinished() {
        return this.artwork.auctionsCatalog.state === this.finishedAuctionsCatalogState;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/artwork_row.vue?20555053